import React from "react";
import { QuesonSection } from "./sections/QuesonSection";
import { ImpactoTraficoSection } from "./sections/ImpactoTraficoSection";
import { ImpactoSectorSection } from "./sections/ImpactoSectorSection";
import { EstrategiasSection } from "./sections/EstrategiasSection";
import { GeoSection } from "./sections/GeoSection";
import { PrediccionesSection } from "./sections/PrediccionesSection";

export function ArticleContent() {
  return (
    <div className="prose prose-lg prose-invert max-w-none">
      <QuesonSection />
      <ImpactoTraficoSection />
      <ImpactoSectorSection />
      <EstrategiasSection />
      <GeoSection />
      <PrediccionesSection />
    </div>
  );
}
